import {Button, Input, InputProps} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import ArrowSVG from '@local/assets/svgs/icon-arrow.svg'
import SpinnerSVG from '@local/assets/svgs/spinner.svg'
import CheckSVG from '@local/assets/svgs/check.svg'
import ErrorSVG from '@local/assets/svgs/input-error.svg'

export interface InputSubmitProps extends InputProps {
	placeholder: string;
	submit: string;
	failure: string;
	isLoading: boolean;
	isSuccess: boolean;
	isFailure: boolean;
	containerClassName?: string;
	submitClassName?: string;
	inputRef?;
}

export const InputSubmit = ({
	className,
	containerClassName,
	submitClassName,
	isLoading,
	isSuccess,
	hasError,
	inputRef,
	...rest
}: InputSubmitProps) => {
	return (
		<div className={cx(containerClassName, 'relative')}>
			<Input ref={inputRef} className={className} {...rest} hasError={hasError} />
			<Button
				className={cx(
					'absolute right-2 bottom-3 p-8 pr-16 h-38 lg:h-42 w-32 bg-grey-5 rounded-sm',
					submitClassName,
				)} type='submit' loading={isLoading}>
				{!isLoading && !isSuccess && !hasError && <ArrowSVG className='w-10' />}
				{isLoading && !isSuccess && <SpinnerSVG className='w-10 animate-spin' fill='currentColor' />}
				{!isLoading && isSuccess && !hasError && <CheckSVG className='w-10' />}
				{!isLoading && !isSuccess && hasError && <ErrorSVG />}
			</Button>
		</div>
	)
}
